<template>
    <div class="language-selector-container" v-click-outside="closeDropdown">
        <div class="selected-lang" @click="toggleDropdown" :class="{ 'is-open': isOpen }">
            <div class="flag-wrapper">
                <img :src="currentLanguage.flagUrl" :alt="currentLanguage.label" class="flag-img" />
            </div>
            <i class="material-icons arrow-icon">keyboard_arrow_down</i>
        </div>
        
        <transition name="dropdown-fade">
            <div v-if="isOpen" class="lang-dropdown">
                <div
                    v-for="lang in languages"
                    :key="lang.code"
                    class="lang-item"
                    :class="{ active: currentLocale === lang.code }"
                    @click="changeLanguage(lang.code)"
                >
                    <div class="flag-wrapper mini">
                        <img :src="lang.flagUrl" :alt="lang.label" class="flag-img" />
                    </div>
                    <span class="lang-label">{{ lang.label }}</span>
                    <i v-if="currentLocale === lang.code" class="material-icons check-icon">check</i>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { setLocale } from '../plugins/i18n';

export default {
    name: 'LanguageSelector',
    directives: {
        'click-outside': {
            bind: function(el, binding, vnode) {
                el.clickOutsideEvent = function(event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind: function(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            },
        },
    },
    data() {
        return {
            isOpen: false,
            languages: [
                { 
                    code: 'pt-BR', 
                    flagUrl: 'https://flagcdn.com/br.svg', 
                    label: 'Português' 
                },
                { 
                    code: 'en',    
                    flagUrl: 'https://flagcdn.com/us.svg', 
                    label: 'English'   
                },
                { 
                    code: 'es',    
                    flagUrl: 'https://flagcdn.com/es.svg', 
                    label: 'Español'   
                },
            ],
        };
    },
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
        currentLanguage() {
            return this.languages.find(l => l.code === this.currentLocale) || this.languages[0];
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        closeDropdown() {
            this.isOpen = false;
        },
        changeLanguage(code) {
            setLocale(code);
            this.isOpen = false;
        },
    },
};
</script>

<style scoped>
.language-selector-container {
    position: relative;
    display: inline-block;
    user-select: none;
}

.selected-lang {
    display: flex;
    align-items: center;
    background: transparent;
    padding: 4px 4px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
}

.selected-lang:hover {
    background: rgba(255, 255, 255, 0.25);
}

.selected-lang.is-open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    background: rgba(255, 255, 255, 0.2);
}

.flag-wrapper {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    border: 1px solid rgba(255,255,255,0.3);
}

.flag-wrapper.mini {
    width: 20px;
    height: 20px;
}

.flag-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1.1);
}

.arrow-icon {
    font-size: 18px;
    color: white;
    margin-left: 4px;
    margin-top: -15px;
    transition: transform 0.2s ease;
}

.selected-lang.is-open .arrow-icon {
    transform: rotate(180deg);
}

.lang-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    min-width: 140px;
    border-radius: 8px;
    border-top-right-radius: 0;
    box-shadow: 0 8px 16px rgba(0,0,0,0.2);
    z-index: 1000;
    overflow: hidden;
    margin-top: 2px;
}

.lang-item {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    cursor: pointer;
    transition: background 0.2s ease;
    color: #333;
    gap: 10px;
}

.lang-item:hover {
    background: #f5f5f5;
}

.lang-item.active {
    background: #f0f7ff;
    color: #1976d2;
    font-weight: 600;
}

.lang-label {
    flex: 1;
    font-size: 14px;
}

.check-icon {
    font-size: 16px;
    color: #4CAF50;
}

/* Transitions */
.dropdown-fade-enter-active, .dropdown-fade-leave-active {
    transition: all 0.2s ease;
}
.dropdown-fade-enter, .dropdown-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue